import ElButton from './src/button';
import '@/theme/css/basic/button.scss';
/* istanbul ignore next */
// ElButton.install = function(Vue) {
//   Vue.component(ElButton.name, ElButton);
// };

export default ElButton;